import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withState, withHandlers, lifecycle, withProps } from 'recompose'
import { FormattedMessage, injectIntl } from 'react-intl'
import { isNil } from 'lodash'

import { fetchingState } from './../helpers/hocs.js'
import { getOptions, pay } from '../store/reducers/giftcards'

import Overlay from '../components/Overlay'
import GiftCardsForm from '../components/GiftCardsForm'
import Form from './../components/Form'
import Select from './../components/Select'
import Loader from '../components/Loader'
import InnerHTML from 'script-inner-html'
import Signin from './Signin'

import validator from 'email-validator'
import { checkLogin, checkEmail, checkPhone } from './../containers/Signin'
import { props } from 'ramda'

import Item from './Categories/Item'

import Textarea from 'react-textarea-autosize'
import DatePicker from "react-datepicker";
import Calendar from 'react-calendar'
import moment from 'moment'
import { getIsLogged, getLoggedUser } from '../selectors/user.js'

const GIFT_CARD_DRAFT_STORAGE_KEY = 'giftcards-buy-draft'

const getDefaultDraft = () => ({
  isOrange: true,
  isFixed: false,
  deliveryDate: undefined
})

const readDraft = () => {
  if (typeof window === 'undefined') return getDefaultDraft()
  try {
    const savedDraft = window.sessionStorage.getItem(GIFT_CARD_DRAFT_STORAGE_KEY)
    return savedDraft ? { ...getDefaultDraft(), ...JSON.parse(savedDraft) } : getDefaultDraft()
  } catch (e) {
    return getDefaultDraft()
  }
}

const writeDraft = (data = {}) => {
  if (typeof window === 'undefined') return
  try {
    window.sessionStorage.setItem(GIFT_CARD_DRAFT_STORAGE_KEY, JSON.stringify(data))
  } catch (e) {}
}

const clearDraft = () => {
  if (typeof window === 'undefined') return
  try {
    window.sessionStorage.removeItem(GIFT_CARD_DRAFT_STORAGE_KEY)
  } catch (e) {}
}

const GiftCardsBuy = ({ data, fetching, formOpened, setFormState, intl,
  success = null, errors, tmpData, setData, peoceed, currentLocale, submit, bidOverlay, setItem, options, setInput, checkout, error, setDeliveryDate, inputCheck,
  isLogged, user, signinOverlay, setSigninOverlay }) => {
  const classPrefix = 'GiftCardsBuy';

  let notificationChannels = { 'phone': intl.formatMessage({ id: 'giftcardsbuy.phone' }) }
  if (tmpData.giverEmail)
    notificationChannels.email = 'Email'

  let denominationOptions = {};
  if (options && options.notFixed) {
    denominationOptions[0] = 'Без фиксированного номинала'
  }
  if (options && options.optionsArray && options.optionsArray.length > 0) {
    denominationOptions[1] = 'Фиксированный номинал'
  }

  return (
    <div className='GiftCardsBuy'>
      <div className='GiftCardsBuy__left'>
        <h1 className='Head GiftCardsBuy__row-xl'>
          От кого
        </h1>
        {(!tmpData.isFixed && options && !options.notFixed) &&
          <div className='GiftCardsBuy__row-s'><FormattedMessage id='giftcardsbuy.no_giftcards' /></div>
        }
        {/*Данные Отправителя */}
        {/*<div className='GiftCardsBuy__row-s'><FormattedMessage id='giftcardsbuy.sender' /></div>*/}
        <input
          className='GiftCardsBuy__input'
          type="text"
          name="giver"
          id="giver"
          placeholder="Имя отправителя"
          onChange={setInput('giver')}
          value={tmpData.giver || ''}
          required
        />
        {errors && errors.giver && <div className='GiftCardsBuy__error'><FormattedMessage id='giftcardsbuy.required' /></div>}
        {/*Выбор номинала карты */}
        {!tmpData.isFixed /*&& options && options.notFixed*/ &&
          <input
            className='GiftCardsBuy__input'
            type="text"
            name="denomination"
            id="denomination"
            placeholder="Номинал от 3 000 до 500 000 руб"
            min="3000"
            max="500000"
            step="1"
            onChange={setInput('denomination')}
            value={tmpData.denominationString || ''}
            required
          />}
        {errors && errors.denomination && <div className='GiftCardsBuy__error'>Номинал сертификата должен быть в диапазоне от 3 000 до 500 000 руб</div>}

        <input
          className='GiftCardsBuy__input'
          //type="number"
          type="email"
          name="giverEmail"
          id="giverEmail"
          placeholder="E-mail"
          onChange={setInput('giverEmail')}
          value={tmpData.giverEmail || ''}
          required
        />
        {errors && errors.giverEmail && <div className='GiftCardsBuy__error'><FormattedMessage id='giftcardsbuy.required_format' /></div>}
        <input
          className='GiftCardsBuy__input'
          //type="number"
          type="tel"
          name="giverPhone"
          id="giverPhone"
          placeholder="Телефон"
          onChange={setInput('giverPhone')}
          value={tmpData.giverPhone || ''}

          required
        />
        {errors && errors.giverPhone && <div className='GiftCardsBuy__error'><FormattedMessage id='giftcardsbuy.required_format' /></div>}

        <div className="GiftCardsBuy__checkbox">
          <input className="custom-checkbox" type="checkbox" id="anonymously" name="anonymously" value={tmpData.anonymously} onChange={inputCheck(this)} />
          <label htmlFor="anonymously">Подарить анонимно</label>
        </div>

        {/* Когда доставить карту */}
        {/*<div className='GiftCardsBuy__row-s'><FormattedMessage id='giftcardsbuy.when' /></div>*/}
        {/*<div className='GiftCardsBuy__row-s-margin'>
          <div className='GiftCardsBuy__column-s'>
            <Item isCurrent={tmpData.deliveryDate === undefined} name="Отправить сейчас"
              isLast={true} onClick={setItem(undefined, 'deliveryDate')} classPrefix={classPrefix} />
          </div>

          <div className='GiftCardsBuy__column-s'>
            {(tmpData.deliveryDate || (tmpData.deliveryDate === undefined)) ? <Item name="Выбрать дату" isCurrent={tmpData.deliveryDate === null} isLast={true}
              onClick={setItem(null, 'deliveryDate')} key={2} classPrefix={classPrefix} /> :
              <div className='GiftCardsBuy__calendar'>
                <Calendar
                  onChange={setDeliveryDate()}
                  value={new Date(tmpData.deliveryDate)}
                  locale={(currentLocale == "en") ? "en" : "ru"}
                  minDate={new Date(new Date().getTime() + 24 * 60 * 60 * 1000)}
                />
              </div>
            }
            {tmpData.deliveryDate && <div className='GiftCardsBuy__date'>{moment(tmpData.deliveryDate).format('DD.MM.YYYY')}</div>}
          </div>
        </div>*/}

        <div className="GiftCardsBuy__checkbox GiftCardsBuy__agreement">
          <input className="custom-checkbox" type="checkbox" id="agreement" name="agreement" value={tmpData.agreement} onChange={inputCheck(this)} />
          <label htmlFor="agreement">Согласен с условиями&nbsp;
            <span><a href="/help/offer" target="_blank" className="mfc-modal__link">
              публичной оферты
            </a></span> и <a href="/giftcards/rules" target="_blank" className="mfc-modal__link">
            <span>Правилами пользования сертификатом</span>
            </a>
          </label>
        {errors && errors.agreement && <div className='GiftCardsBuy__error'>Необходимо согласие с условиями</div>}
        </div>
      </div>
      <div className='GiftCardsBuy__center'>

        {/* Данные Получателя */}
        <h1 className='Head GiftCardsBuy__row-xl'>Кому</h1>
        {/*<div className='GiftCardsBuy__row-s'><FormattedMessage id='giftcardsbuy.recipient' /></div>*/}
        <input
          className='GiftCardsBuy__input'
          type="text"
          name="name"
          id="name"
          placeholder="Имя получателя"
          onChange={setInput('name')}
          value={tmpData.sendMe ? '' : (tmpData.name || '')}
          required
          disabled={tmpData.sendMe}
        />
        {errors && errors.name && <div className='GiftCardsBuy__error'><FormattedMessage id='giftcardsbuy.required' /></div>}
        <input
          className='GiftCardsBuy__input'
          //type="number"
          type="email"
          name="email"
          id="email"
          placeholder="E-mail"
          onChange={setInput('email')}
          value={tmpData.sendMe ? '' : (tmpData.email || '')}
          required
          disabled={tmpData.sendMe}
        />
        {errors && errors.email && <div className='GiftCardsBuy__error'><FormattedMessage id='giftcardsbuy.required_format' /></div>}
        <input
          className='GiftCardsBuy__input'
          //type="number"
          type="tel"
          name="phone"
          id="phone"
          placeholder="Телефон (необязательно)"
          onChange={setInput('phone')}
          value={tmpData.sendMe ? '' : (tmpData.phone || '')}
          required
          disabled={tmpData.sendMe}
        />
        {/*errors && errors.phone && <div className='GiftCardsBuy__row-s-margin'><FormattedMessage id='giftcardsbuy.required_phone_email' /></div>*/}
        {errors && errors.phone && <div className='GiftCardsBuy__error'><FormattedMessage id='giftcardsbuy.required_format' /></div>}
        <div className="GiftCardsBuy__checkbox">
          <input className="custom-checkbox" type="checkbox" id="sendMe" name="sendMe" value={tmpData.sendMe} onChange={inputCheck(this)} />
          <label htmlFor="sendMe">Отправьте сертификат мне, я сам вручу его получателю!</label>
        </div>

        {/* Комментарий */}
        <div className='GiftCardsBuy__row-s'>
          Ваше сообщение (необязательно)
        </div>
        <div className='GiftCardsBuy__textarea-wrap'>
          <Textarea className='GiftCardsBuy__textarea' value={tmpData.text} onChange={setInput('text')} minRows={4} placeholder=''/>
        <div className='GiftCardsBuy__textarea-restriction'>{tmpData.text ? tmpData.text.length : 0}/300</div>
        </div>


        {/*Электронная/физическая карта
        <div className='GiftCardsBuy__row-m'>
          <div className='GiftCardsBuy__column-m'>
            <Item isCurrent={tmpData.cardtype == 'ecard'} name={intl.formatMessage({ id: 'giftcardsbuy.ecard' })} value={2}
              isLast={true} onClick={setItem('ecard', 'cardtype')} classPrefix={classPrefix} />
          </div>

          <div className='GiftCardsBuy__column-m'>
            <Item name={intl.formatMessage({ id: 'giftcardsbuy.mcard' })} isCurrent={tmpData.cardtype == 'mcard'} isLast={true} value={2}
              onClick={setItem('mcard', 'cardtype')} key={2} classPrefix={classPrefix} />
          </div>
        </div>

        {/*Фиксированная.нефиксированная сумма /}
        <div className='GiftCardsBuy__row-s'>
          <div className='GiftCardsBuy__column-s'>
            <Item isCurrent={tmpData.isFixed} name={intl.formatMessage({ id: 'giftcardsbuy.fixprice' })} value={2}
              isLast={true} onClick={setItem(true, 'isFixed')} classPrefix={classPrefix} />
          </div>

          <div className='GiftCardsBuy__column-s'>
            <Item name={intl.formatMessage({ id: 'giftcardsbuy.non_fixprice' })} isCurrent={!tmpData.isFixed} isLast={true} value={1}
              onClick={setItem(false, 'isFixed')} key={2} classPrefix={classPrefix} />
          </div>
        </div>



        {/*((!tmpData.isFixed && options && !options.notFixed) || (tmpData.isFixed && options && options.optionsArray && options.optionsArray.lenght == 0)) &&
          <div className='GiftCardsBuy__row-s'><FormattedMessage id='giftcardsbuy.no_giftcards' /></div>
        }*/}



        {/*{(tmpData.isFixed && options && options.optionsArray && options.optionsArray)
          &&
          <div className="GiftCardsBuy__select-wrap">
            <Select class=" GiftCardsBuy__Select" classname="GiftCardsBuy__select" scrollclass="GiftCardsBuy-scroll" classItem="GiftCardsBuy__Select-item"
              placeholder={intl.formatMessage({ id: 'giftcardsbuy.choose_denom' })} value={tmpData.notificationChannel}
              items={options.optionsArray} onSubmit={peoceed.bind(this, 'denomination')} required />
          </div>
        }

      {tmpData.isFixed && <div className='GiftCardsBuy__row-xs'><FormattedMessage id='giftcardsbuy.attention' /></div>*/}





      </div>
      <div className='GiftCardsBuy__right'>

        <img className='GiftCardsBuy__right-img' src={"/assets/img/giftcards/certificate-orange-new.jpg"}
          alt="" />



        {/*<div className="GiftCardsBuy__select-wrap">
          <Select class=" GiftCardsBuy__Select" classname="GiftCardsBuy__select" scrollclass="GiftCardsBuy-scroll" classItem="GiftCardsBuy__Select-item"
            placeholder={intl.formatMessage({ id: 'giftcardsbuy.notification_channel' })} value={tmpData.notificationChannel}
            items={notificationChannels} onSubmit={peoceed.bind(this, 'notificationChannel')} required />
        </div>
        <div className='GiftCardsBuy__row-marginselect'></div>
        {errors && errors.notificationChannel && <div className='GiftCardsBuy__row-s-margin'><FormattedMessage id='giftcardsbuy.required' /></div>*/}



        {/*Белый/оранжевый */}
        {/*<div className='GiftCardsBuy__orange'>
          <div className='GiftCardsBuy__column-s'>
            <input className="custom-checkbox" type="checkbox" id="isWhite" name="isWhite" checked={!tmpData.isOrange} onChange={inputCheck(this)} />
            <label htmlFor="isWhite">Белый</label>
          </div>

          <div className='GiftCardsBuy__column-s'>
          <input className="custom-checkbox" type="checkbox" id="isOrange" name="isOrange" checked={tmpData.isOrange} onChange={inputCheck(this)} />
            <label htmlFor="isOrange"  className={classPrefix}>Оранжевый</label>
          </div>
      </div>*/}



        {(errors && (Object.keys(errors).length > 0)) &&  <div className='GiftCardsBuy__error-last'>Введены некорректные данные</div>}
        {error && <div className='GiftCardsBuy__error-last'>{error}</div>}
        {!isLogged && <div className='Text'>Покупка доступна после входа в аккаунт. После нажатия мы попросим вас войти, введенные данные сохранятся.</div>}
        {isLogged && user && user.role && user.role !== 'user' && <div className='Text'>Покупка доступна только в роли пользователя.</div>}
          <div className='GiftCardsBuy__button-wrap'>
            <button className='Button GiftCardsBuy__button' onClick={submit}>
              {isLogged ? 'Подарить' : 'Войти и купить'}
            </button>
          </div>


        {(fetching.send || fetching.info) && <Loader isLight />}
        {!isNil(success) && <div className='Text'> {/*Error - before checkout open*/} </div>}
        {success && checkout &&
          <div>
              <InnerHTML html={checkout.exec} />
          </div>
        }
      </div>

      <Overlay isActive={signinOverlay} onClose={() => setSigninOverlay(false)}>
        <Signin onClose={() => setSigninOverlay(false)} registrationLogin />
      </Overlay>
    </div>
  )
}

const mapStateToProps = state => ({
  ...state.contacts,
  currentLocale: state.intl.locale,
  ...state.feedback, ...state.giftcards, ...state.pay,
  isLogged: getIsLogged(state),
  user: getLoggedUser(state)
})

const mapDispatchToProps = dispatch => bindActionCreators({ getOptions, pay }, dispatch)

export default injectIntl(compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('formOpened', 'setFormState', false),

  //withState('data', 'setData', {}),
  withState('tmpData', 'setTmpData', {isOrange: true, isFixed: false, deliveryDate: undefined}),
  withState('success', 'setSuccess', null),
  withState('errors', 'setErrors', {}),//ошибки заполнения формы
  withState('error', 'setError', ''),//ошибки при процессе покупки
  withState('signinOverlay', 'setSigninOverlay', false),
  fetchingState({ multi: true }),
  withHandlers({
    inputCheck: ({ setTmpData, tmpData }) => field => e => {
      console.log('e.target.name', e.target.name, e.target.checked)
      let nextTmpData = { ...tmpData }

      if (e.target.name == 'isWhite') {
        nextTmpData.isOrange = false//(e.target.checked)
      } else if (e.target.name == 'isOrange') {
        nextTmpData.isOrange = true
      } else {
        nextTmpData[e.target.name] = e.target.checked
      }

      writeDraft(nextTmpData)
      setTmpData(nextTmpData)
    },
    setDeliveryDate: ({ setTmpData, tmpData, /*data, setData*/ }) => field => value => {
      const nextTmpData = { ...tmpData, deliveryDate: value }
      writeDraft(nextTmpData)
      setTmpData(nextTmpData)
    },
    setInput: ({ setTmpData, tmpData }) => field => e => {//запись данных при записи в input
      console.log('setInput',field, e.target.value)
      const nextTmpData = { ...tmpData }
      if (field == 'text') {//условие - не более 300 символов
        nextTmpData[field] = e.target.value.substring(0, 300)
      } else if (field == "denomination") {
        nextTmpData.denominationString = e.target.value.replace(/\s/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, " ")
        nextTmpData[field] = Number(e.target.value.replace(/\s/g, ''))
      } else {
        nextTmpData[field] = e.target.value
      }
      writeDraft(nextTmpData)
      setTmpData(nextTmpData)
    },
    setData: ({ setTmpData, tmpData }) => field => e => {
      const nextTmpData = { ...tmpData, [field]: e }
      writeDraft(nextTmpData)
      setTmpData(nextTmpData)
    },
    /*clearData: ({ setData }) => () => {
      //setData({})
      setTmpData(tmpData)
    },*/
    peoceed: ({ /*setData, data,*/ setTmpData, tmpData, options }) => (field, e) => {//запись данных при выборе в select
      e && e.preventDefault && e.preventDefault()
      if (field == 'denomination') {
        const nextTmpData = { ...tmpData, [field]: options.optionsArray[e] }
        writeDraft(nextTmpData)
        setTmpData(nextTmpData)
      } else {
        const nextTmpData = { ...tmpData, [field]: e }
        writeDraft(nextTmpData)
        setTmpData(nextTmpData)
      }
    },
    setItem: ({ /*setData, data,*/ setTmpData, tmpData, options }) => (value, field) => () => {//выбор из двух item (тип карты, фикс/нефиксированная, дата доставки)
      console.log('field', field, value)
      if (field == "isFixed") {
        const nextTmpData = { ...tmpData, [field]: value, denomination: null }
        writeDraft(nextTmpData)
        setTmpData(nextTmpData)
        //data.denomination = null
      } else {
        const nextTmpData = { ...tmpData, [field]: value }
        writeDraft(nextTmpData)
        setTmpData(nextTmpData)
      }
    },
    submit: ({ tmpData, /*data,*/ setSuccess, fetchingWrap, pay, noLoader = true, setErrors, setError, isLogged, setSigninOverlay, user }) => async e => {//отправка данных на сервер
      e && e.preventDefault()
      setSuccess(null)
      setError('')

      let data = { ...tmpData }
      writeDraft(data)

      let errors = {};
      if (!data.denomination || (Number(data.denomination) < 3000) || (Number(data.denomination) > 500000)) errors.denomination = true
      if (!data.giver) errors.giver = true
      if (!data.giverEmail || !validator.validate(data.giverEmail)) errors.giverEmail = true
      if (!data.giverPhone || !checkPhone(data.giverPhone)) errors.giverPhone = true
      //if (!data.notificationChannel) errors.notificationChannel = true
      if (!data.name && !data.sendMe) errors.name = true
      //if ((!data.email || !validator.validate(data.email)) && (!data.phone || !checkLogin(data.phone))) errors.email = true
      if (!data.sendMe && (!data.email || !validator.validate(data.email))) errors.email = true
      if (data.phone && !data.sendMe && !checkPhone(data.phone)) errors.phone = true
      if (!data.agreement) errors.agreement = true
      //if (!data.comment) errors.comment = true
      setErrors(errors)

      if (Object.keys(errors).length === 0) {
        if (!isLogged) {
          setSigninOverlay(true)
          return
        }

        if (user && user.role && user.role !== 'user') {
          setError('Покупка доступна только в роли пользователя')
          return
        }

        if (data.sendMe) {
          delete data.name
          delete data.phone
          delete data.email
        }

        const result = noLoader ? await pay(data) : await fetchingWrap(pay.bind(this, data))
        
        if (result === 200) {
          setSuccess(true)
          setError('')
          clearDraft()
        } else if (result === 409) {
          setSuccess(true)
          setError('Доступных карт данного типа нет в наличии')
        } else {
          setSuccess(true)
          setError('Ошибка')
        }
      }
    }
  }),
  /*withProps(props => {console.log('props', props.info)
    return ({
      //data: { ...props.info, ...props.data, ...props.options },
      tmpData: { giver: props.info.name, giverPhone: props.info.phone, giverEmail: props.info.email,
        isOrange: true, isFixed: false, deliveryDate: undefined, ...props.tmpData }
    })
  }),*/
  lifecycle({
    componentWillMount() {
      //this.props.clearData()
      //this.props.setTmpData()//значения по умолчанию
      const nextTmpData = {
        ...getDefaultDraft(),
        ...readDraft()
      }
      if (this.props.info) {
        if (!nextTmpData.giver && this.props.info.name) nextTmpData.giver = this.props.info.name
        if (!nextTmpData.giverPhone && this.props.info.phone) nextTmpData.giverPhone = this.props.info.phone
        if (!nextTmpData.giverEmail && this.props.info.email) nextTmpData.giverEmail = this.props.info.email
      }
      writeDraft(nextTmpData)
      this.props.setTmpData(nextTmpData)
      this.props.getOptions()
    },
    componentWillReceiveProps (np) {
      if (!this.props.isLogged && np.isLogged && this.props.signinOverlay) {
        this.props.setSigninOverlay(false)
      }

      if (np.info && np.info !== this.props.info){
        const nextTmpData = {
          ...getDefaultDraft(),
          ...readDraft(),
          ...this.props.tmpData
        }
        if (!nextTmpData.giver && np.info.name) nextTmpData.giver = np.info.name
        if (!nextTmpData.giverPhone && np.info.phone) nextTmpData.giverPhone = np.info.phone
        if (!nextTmpData.giverEmail && np.info.email) nextTmpData.giverEmail = np.info.email
        writeDraft(nextTmpData)
        this.props.setTmpData(nextTmpData)
      }
    },
    componentWillUnmount() {
      this.props.setTmpData({})
      this.props.setSuccess(null)
      //this.props.clearData()
    }
  })
)(GiftCardsBuy))



// WEBPACK FOOTER //
// ./src/containers/GiftCardsBuy.jsx